import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import * as HostStates from './../Types/HostStateTypes';
function OnlineStateIcon(_a) {
  var state = _a.state;
  if ([HostStates.OFFLINE, HostStates.OFFLINE0900].indexOf(state) !== -1) {
    return null;
  }
  var color = "yellow";
  if (state === HostStates.FREE) {
    color = 'green';
  }
  return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCircle,
    className: color
  });
}
export default OnlineStateIcon;